export default __webpack_public_path__ + "static/media/phoenix.2dd4bac0.png";